export const Footer = (props) => {

  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; Sm4rt Change 2021
          </p>
        </div>
      </div>
    </div>
  )
}
